import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import TopicInfo from '../../topic-info';
import { ContextMenuAction } from '../../activity-header/styled';
import { Select, Results } from '../../../helpers/icon-dictionary';

const StatusCellMenu = ({
  i18n,
  studentName,
  activityName,
  assignmentDates,
  attempts,
  score,
  hasAssignment,
  isInstructionHubBlocked,
  onSelectCell,
  onSelectAllBelow,
  onUnassign,
  onReassign,
  onViewResults
}) => (
  <>
    <TopicInfo
      displayHideOption={false}
      standardName={studentName}
      subName={activityName}
      externalKey={assignmentDates}
      ljName={`${attempts} ${
        attempts > 1
          ? i18n.t('StatusCell.Attempts')`attempts`
          : i18n.t('StatusCell.Attempt')`attempt`
      }`}
    />
    <ContextMenuAction
      data-testid="select-cell"
      role="button"
      first
      tabIndex="-1"
      blackListed={isInstructionHubBlocked}
      onClick={(e) => {
        e.stopPropagation();
        onSelectCell();
      }}
    >
      <Isvg src={Select} cacheGetRequests />
      {i18n.t('StatusCell.SelectCell')`Select cell`}
    </ContextMenuAction>
    <ContextMenuAction
      data-testid="select-all-less-than"
      role="button"
      first
      tabIndex="-1"
      blackListed={isInstructionHubBlocked}
      onClick={(e) => {
        e.stopPropagation();
        onSelectAllBelow();
      }}
    >
      {
        /* eslint-disable indent */
        `${i18n.t('StatusCell.SelectLessThan')`Select all <=`} ${score}%`
        /* eslint-enable indent */
      }
    </ContextMenuAction>
    <ContextMenuAction
      data-testid="unassign-from-student"
      role="button"
      first
      tabIndex="-1"
      blackListed={!hasAssignment || isInstructionHubBlocked}
      onClick={(e) => {
        e.stopPropagation();
        if (hasAssignment) {
          onUnassign();
        }
      }}
    >
      {`${i18n.t('StatusCell.Unassign')`Unassign from student`}`}
    </ContextMenuAction>
    <ContextMenuAction
      data-testid="reassign"
      role="button"
      first
      tabIndex="-1"
      blackListed={hasAssignment || isInstructionHubBlocked}
      onClick={(e) => {
        e.stopPropagation();
        if (!hasAssignment) {
          onReassign();
        }
      }}
    >
      {`${i18n.t('StatusCell.Reassign')`Reassign`}`}
    </ContextMenuAction>
    <ContextMenuAction
      data-testid="ViewResults"
      role="button"
      last
      tabIndex="-1"
      onClick={onViewResults}
    >
      <Isvg src={Results} cacheGetRequests />
      {`${i18n.t('StatusCell.viewResults')`View Results`}`}
    </ContextMenuAction>
  </>
);

StatusCellMenu.propTypes = {
  i18n: PropTypes.object.isRequired,
  studentName: PropTypes.string.isRequired,
  activityName: PropTypes.string,
  assignmentDates: PropTypes.string.isRequired,
  attempts: PropTypes.number,
  score: PropTypes.number.isRequired,
  hasAssignment: PropTypes.bool.isRequired,
  isInstructionHubBlocked: PropTypes.bool,
  onSelectCell: PropTypes.func.isRequired,
  onSelectAllBelow: PropTypes.func.isRequired,
  onUnassign: PropTypes.func.isRequired,
  onReassign: PropTypes.func.isRequired,
  onViewResults: PropTypes.func.isRequired
};

StatusCellMenu.defaultProps = {
  isInstructionHubBlocked: false
};

export default StatusCellMenu;



// WEBPACK FOOTER //
// ./components/status-cell/status-cell-menu/index.js